<template>
  <div class="top barging-container">
    <div class="barging-card" style="padding: 0; margin-top: 0; background-color: #f2f7fa; border-radius: 10px;">

      <div class="w-full searchBar" ref="searchBarRef" id="pdMeterAuditLogBar">
        <div class="flex flex-wrap justify-end">
          <div class="flex flex-row py-2 pr-1">
            <el-date-picker
              v-model="params.dateRange"
              type="datetimerange"
              size="mini"
              start-placeholder="Change Date Start"
              end-placeholder="Change Date End"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :style="{ width: '380px' }"
            />
          </div>
          <div class="flex flex-row py-2 pr-1">
            <el-input
              v-model="params.searchValue"
              size="mini"
              clearable
              placeholder="Nomination ID / Meter Serial / Changed By"
              :style="{ width: '320px' }"
              @keyup.enter.native="handleSearch"
            />
          </div>
          <div class="flex flex-row pl-1 py-2">
            <el-button size="mini" type="primary" @click="handleSearch">Search</el-button>
            <el-button size="mini" type="success" :loading="exporting" @click="handleExport">Export Excel</el-button>
          </div>
        </div>
      </div>

      <div class="box-card barging-table" v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="w-full Comtable" id="pdMeterAuditLogTable" ref="tableRef">
          <el-table
            :data="listData"
            :header-cell-style="tableHeaderStyle"
            :cell-style="getCellStyle"
            table-layout="auto"
            height="100%"
            v-loading="loading"
          >
            <el-table-column align="left" prop="nominationId" label="Nomination ID" min-width="140" />
            <el-table-column align="left" prop="beforeValue" label="Before Change Value" min-width="160" />
            <el-table-column align="left" prop="afterValue" label="After Change Value" min-width="160" />
            <el-table-column align="left" prop="meterSerialNo" label="Meter Serial Number" min-width="180" />
            <el-table-column align="left" prop="changeBy" label="Changed By" min-width="160" />
            <el-table-column align="left" prop="changeTime" label="Change Date & Time" min-width="180" />
          </el-table>
        </div>
      </div>

      <div class="barging-pagination">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="params.pageNum"
          :limit.sync="params.pageSize"
          :pageSizes="[20, 30, 50, 100]"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getPdMeterAuditLog, exportPdMeterAuditLog, downloadFile } from "@/services/index.js";
import { mapState } from "vuex";

export default {
  name: "PdMeterAuditLog",
  data() {
    return {
      listData: [],
      total: 0,
      loading: false,
      exporting: false,
      params: {
        pageNum: 1,
        pageSize: 20,
        dateRange: null,
        searchValue: null,
      },
    };
  },
  computed: {
    ...mapState(["screenType", "userInfo"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    tableHeaderStyle() {
      return {
        height: "55px",
        background: "#fff",
        "border-bottom": "2px solid #D6D9E1",
      };
    },
  },
  created() {
    this.getList();
  },
  mounted() {
    this.adjustHeight();
    window.addEventListener("resize", this.adjustHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustHeight);
  },
  methods: {
    adjustHeight() {
      const barEl = document.getElementById("pdMeterAuditLogBar");
      const tableEl = document.getElementById("pdMeterAuditLogTable");
      if (!barEl || !tableEl) return;
      const barHeight = barEl.offsetHeight;
      const isMobile = window.innerWidth < 1025;
      const overhead = isMobile ? 235 : 202;
      tableEl.style.height = `calc(100vh - ${barHeight + overhead}px)`;
    },

    buildFilter(payload) {
      if (this.params.dateRange && this.params.dateRange.length === 2) {
        payload.startDate = this.params.dateRange[0];
        payload.endDate = this.params.dateRange[1];
      }
      if (this.params.searchValue) {
        payload.searchValue = this.params.searchValue;
      }
      return payload;
    },

    async getList() {
      this.loading = true;
      try {
        const payload = this.buildFilter({
          pageNum: this.params.pageNum,
          pageSize: this.params.pageSize,
        });
        const res = await getPdMeterAuditLog(payload);
        this.listData = res.rows || [];
        this.total = res.total || 0;
      } finally {
        this.loading = false;
      }
    },

    handleSearch() {
      this.params.pageNum = 1;
      this.getList();
    },

    async handleExport() {
      this.exporting = true;
      try {
        const data = await exportPdMeterAuditLog(this.buildFilter({}));
        const today = new Date();
        const ymd = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;
        downloadFile(data, `pd-meter-audit-log-${ymd}.xls`);
      } catch {
        this.$message.error('Export failed');
      } finally {
        this.exporting = false;
      }
    },

    getCellStyle({ rowIndex }) {
      return {
        backgroundColor: rowIndex % 2 === 0
          ? "rgba(228,228,228,0.2)"
          : "rgba(255,255,255,0.2)",
      };
    },
  },
};
</script>

<style scoped lang="scss">
.barging-container {
  border-radius: 10px;
}

.searchBar {
  width: 100% !important;
  background-color: #f3f7fa;
  font-size: 11px;
  color: #1d1b20;
  font-family: "Roboto";
  padding: 0 10px;
}

::v-deep .pagination-container {
  background: #f2f7fa;
}

::v-deep .el-table td.el-table__cell {
  vertical-align: top;
}

::v-deep .el-table .cell {
  word-break: break-word;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}
</style>
